<template>
  <v-container v-if="loan">
    <section class="mt-2 mb-4">
      <h1 v-if="me" class="font-size--24">
        {{ me.name }} 사장님의 상환내역
      </h1>
      <p class="color--nice-grey mb-0">(상환이 완료된 후 재대출이 가능합니다.)</p>
    </section>

    <section>
      <v-card>
        <v-card-subtitle class="pb-1 color--nice-grey">
          실행일 {{ $moment(loan.executedAt).format() }} ~ 만기일
          {{ $moment(loan.executedAt).add(loan.offer.periodInDays, 'd').format() }}
        </v-card-subtitle>
        <v-card-text class="font-size--18 font-weight-bold color--nice-black">
          <v-layout justify-space-between class="mb-1">
            <span>{{ isCollection ? '집금액' : '대출원금' }}</span>
            <span>{{ commaFormat(loan.amount) }} 원</span>
          </v-layout>
          <v-layout justify-space-between>
            <span>{{ isCollection ? '집금잔액' : '대출잔액' }}</span>
            <span>{{ commaFormat(loan.leftAmount) }} 원</span>
          </v-layout>
        </v-card-text>
      </v-card>
    </section>

    <section v-if="repayments.length > 0" class="mt-8">
      <RepaymentListItem
        v-for="(item, index) in repayments"
        :key="index"
        :item="item"
        :isCollection="isCollection"
      />
    </section>

    <section v-if="finishedLoans.length > 0" class="mt-8">
      <h1 class="font-size--18 mb-2">상환완료된 {{ isCollection ? '집금내역' : '대출내역' }}</h1>
      <table>
        <thead class="text-center">
          <td>실행일</td>
          <td>{{ isCollection ? '집금액' : '대출원금' }}</td>
          <td>{{ isCollection ? '집금잔액' : '대출잔액' }}</td>
          <td>채권상태</td>
        </thead>
        <tr v-for="(item, index) in finishedLoans" :key="index">
          <td class="text-center">{{ $moment(item.executedAt).format() }}</td>
          <td class="text-right">{{ commaFormat(item.amount) }}</td>
          <td class="text-right">{{ commaFormat(item.leftAmount) }}</td>
          <td class="text-center">상환완료</td>
        </tr>
      </table>
    </section>

    <section class="mt-12">
      <v-layout justify-center>
        <v-btn
          text
          color="grey"
          height="25"
          style="text-decoration: underline"
          :to="'/'"
        >
          돌아가기
        </v-btn>
      </v-layout>
    </section>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { commaFormat } from '@/filter/number'
import RepaymentListItem from '@/components/loan/RepaymentListItem.vue'
import { sortAsc } from '@/util'

export default {
  components: { RepaymentListItem },
  data() {
    return {
      loan: null,
      repayments: [],
      finishedLoans: [],
    }
  },
  async created() {
    this.loan = await this.getLoansDetail(this.$route.params.uuid)
    this.repayments = await this.getLoansRepayments(this.$route.params.uuid)
    const loans = await this.getLoans({ status: 'finished', type: this.loan.type })
    // 집금(자동집금) 화면인 경우에는 BNPL_COLLECTION만 하단 표에 노출
    const filtered = this.loan?.offer?.loanType === 'BNPL_COLLECTION'
      ? (loans || []).filter((l) => l?.offer?.loanType === 'BNPL_COLLECTION')
      : loans
    this.finishedLoans = sortAsc(filtered, 'executedAt')
  },
  computed: {
    ...mapState('auth', ['me']),
    isCollection() {
      return this.loan?.offer?.loanType === 'BNPL_COLLECTION'
    },
  },
  methods: {
    commaFormat,
    ...mapActions('loan', ['getLoans', 'getLoansRepayments', 'getLoansDetail']),
  },
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  td {
    border: 1px solid #aeaeae;
    padding: 2px 6px;
    font-size: 13px;
  }
}
</style>